export default __webpack_public_path__ + "static/media/oxxo.dfcaee0a.png";